import React from 'react';
import { Alert, AlertTitle, Button, Box } from '@mui/material';

/**
 * Maps an axios/fetch error to a human-readable title + message. Auth failures
 * (401/403) are explained as access problems rather than generic errors so an
 * empty/blocked view is never silently shown as "no data".
 */
export function describeError(error) {
  const status = error?.response?.status;
  if (status === 401) {
    return {
      severity: 'warning',
      title: 'Not provisioned for provider access',
      message:
        'You are signed in, but your account is not authorised for the 24K.Infinity provider plane yet. Ask an administrator to grant you the provider_admin role.',
    };
  }
  if (status === 403) {
    return {
      severity: 'warning',
      title: 'Access denied',
      message: 'You do not have provider-admin permission for this resource.',
    };
  }
  return {
    severity: 'error',
    title: 'Could not load data',
    message: error?.message || 'An unexpected error occurred. Please retry.',
  };
}

export default function LoadError({ error, onRetry, sx }) {
  if (!error) return null;
  const { severity, title, message } = describeError(error);
  return (
    <Box sx={{ py: 2, ...sx }}>
      <Alert
        severity={severity}
        action={
          onRetry ? (
            <Button color="inherit" size="small" onClick={onRetry}>
              Retry
            </Button>
          ) : null
        }
      >
        <AlertTitle>{title}</AlertTitle>
        {message}
      </Alert>
    </Box>
  );
}
